import { useEffect } from 'react';

const STORAGE_KEY_PREFIX = 'librerank_code_';

/**
 * Hook to persist code to localStorage per problem
 */
export function useCodePersistence(problemId: string | null, code: string) {
  // Save code to localStorage whenever it changes
  useEffect(() => {
    if (problemId && code) {
      const key = STORAGE_KEY_PREFIX + problemId;
      localStorage.setItem(key, code);
    }
  }, [problemId, code]);
}

/**
 * Load saved code for a problem, or return starter code if none exists
 */
export function loadSavedCode(problemId: string, starterCode: string): string {
  const key = STORAGE_KEY_PREFIX + problemId;
  const saved = localStorage.getItem(key);
  return saved || starterCode;
}

/**
 * Clear saved code for a problem
 */
export function clearSavedCode(problemId: string): void {
  const key = STORAGE_KEY_PREFIX + problemId;
  localStorage.removeItem(key);
}
